export const SkeletonCard = () => (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
        <div className="team-card skeleton">
            <div className="team-image-wrapper shimmer-bg skeleton-img" />
            <div className="team-info">
                <div className="skeleton-text skeleton-name shimmer-bg" />
                <div className="skeleton-text skeleton-title shimmer-bg" />
                <div className="skeleton-text skeleton-position shimmer-bg" />
                <div className="skeleton-button shimmer-bg" />
            </div>
        </div>
    </div>
);
